import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Grid,
  TextField
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const CumulativeFlightTimeLimits = ({ baseline, handleChange, aircraftType }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="h6">Cumulative Flight Time Limits</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Flight Time (7 Days)"
              type="number"
              value={baseline.maxFlightTime7Days}
              onChange={(e) => handleChange('maxFlightTime7Days', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 100, step: 0.5 }}
              helperText={aircraftType === 'Helicopter' ? 'PDF 6.1.2.b: 30 hours (Helicopter)' : 'Para 9.1: 35 hours (Fixed Wing)'}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Flight Time (28 Days)"
              type="number"
              value={baseline.maxFlightTime28Days}
              onChange={(e) => handleChange('maxFlightTime28Days', parseFloat(e.target.value))}
              inputProps={{ min: 1, max: 500, step: 0.5 }}
              helperText="CAR Section 7, Series J - 28 consecutive days"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Flight Time (Annual)"
              type="number"
              value={baseline.maxFlightTimeAnnual}
              onChange={(e) => handleChange('maxFlightTimeAnnual', parseFloat(e.target.value))}
              inputProps={{ min: 100, max: 2000, step: 1 }}
              helperText="CAR Section 7, Series J - Calendar year"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Max Duty Time (Annual)"
              type="number"
              value={baseline.maxDutyTimeAnnual}
              onChange={(e) => handleChange('maxDutyTimeAnnual', parseFloat(e.target.value))}
              inputProps={{ min: 500, max: 3000, step: 1 }}
              helperText="CAR Section 7, Series J - Calendar year"
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default CumulativeFlightTimeLimits;
